module.exports = __webpack_public_path__ + "static/media/manual2.13cf8542.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/manual2.pdf
// module id = 769
// module chunks = 0